import google from 'assets/img/logos/01.png';
import netflix from 'assets/img/logos/02.png';
import amazon from 'assets/img/logos/03.png';

export default [
  {
    description:
      'Компанийн профайл вэбсайт нь таны бизнесийг онлайнаар байршуулж, боломжит үйлчлүүлэгчид болон үйлчлүүлэгчдэд таныг хялбархан олох боломжийг олгодог. Энэ нь хүмүүс танай компани, бүтээгдэхүүн, үйлчилгээ, үнэт зүйлсийн талаар мэдэх боломжтой дижитал дэлгүүрийн нүүр хуудас болж үйлчилдэг.',
    author: 'Scott Tolinski',
    designation: 'Web Developer',
    companyImage: google,
    size: 60
  },
  {
    description:
      'Вэбсайттай бол та илүү өргөн хүрээний үзэгчдэд хүрч, бодит байршлаас гадна харагдах байдлыг нэмэгдүүлэх боломжтой. Энэ нь танай бизнесийн талаар мэдэхгүй байж болох үйлчлүүлэгчдийг татах боломжийг үндэсний хэмжээнд эсвэл бүр дэлхийн хэмжээнд өргөжүүлэх боломжийг олгоно.',
    author: 'Jeff Escalante',
    designation: 'Developer',
    companyImage: netflix,
    size: 60
  },
  {
    description:
      'Вэбсайтад 24/7 хандах боломжтой. Үйлчлүүлэгчид хүссэн үедээ таны вэб сайтад зочилж мэдээлэл цуглуулах, лавлагаа авах, тэр ч байтугай цагийн бүсийн ялгаа, баярын өдрүүдээс үл хамааран ажиллах болно.',
    author: 'Liam Martens',
    designation: 'Designer',
    companyImage: amazon,
    size: 60
  }
];
